export default function PictureCampaignModel(dict) {
    this.ID = dict.ID;
    this.campaignID = dict.CampaignID;
    this.caption = dict.Caption;
    this.sequence = dict.Sequence;
    this.imageUrl = dict.ImageUrl;
    this.fullImageUrl = dict.FullImageUrl;

    if (this.fullImageUrl) {
        if(this.fullImageUrl.indexOf("-large") < 0) {
            var newString = this.fullImageUrl.replace("?", "-large?");
            this.fullImageUrl = newString;
        }
    }
}
